import { render, staticRenderFns } from "./imgZoom.vue?vue&type=template&id=4e5f3132"
import script from "./imgZoom.vue?vue&type=script&lang=js"
export * from "./imgZoom.vue?vue&type=script&lang=js"
import style0 from "./imgZoom.vue?vue&type=style&index=0&id=4e5f3132&prod&lang=scss&paged=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports